<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-container>
        <div class="agent-edit">
          <b-card>
            <div slot="header">Add Agent</div>
            <!--card-body-->
            <v-text-field :v="$v.form['name']" v-model="form.name" type="text" name="name"
                          placeholder="Enter your company name" :required="true" @blur="$v.form['name'].$touch()"
                          @focus="$v.form['name'].$reset()">
              <span slot="label">Company Name</span>
            </v-text-field>
            <v-text-field :v="$v.form['reference_id']" v-model="form.reference_id" type="text" name="referenceId"
                          placeholder="1234567890" :required="true" @blur="$v.form['reference_id'].$touch()"
                          @focus="$v.form['reference_id'].$reset()">
              <span slot="label">Reference Id</span>
            </v-text-field>

            <v-text-field v-model="form.vat" type="text" name="vat" placeholder="M0000-0000" :required="true">
              <span slot="label">VAT Number</span>
            </v-text-field>

            <!--Address-->
            <b-row>
              <b-col>
                <v-text-field v-model="form.building" type="text" name="building" placeholder="Court A"
                              :required="false">
                  <span slot="label">Building</span>
                </v-text-field>
              </b-col>
              <b-col>
                <v-text-field v-model="form.street" type="text" name="street" placeholder="1st Street"
                              :required="false">
                  <span slot="label">Street</span>
                </v-text-field>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <v-text-field v-model="form.city" type="text" name="city" placeholder="City" :required="false">
                  <span slot="label">City</span>
                </v-text-field>
              </b-col>
              <b-col>
                <v-select-field v-model="form.country" :v="$v.form['country']" :options="select2Countries" type="text"
                                name="country" placeholder="Select Country" :required="true"
                                @blur="$v.form['country'].$touch()">
                  <span slot="label">Select Country</span>
                </v-select-field>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <v-text-field v-model="form.postcode" type="text" name="postcode" placeholder="PC1234"
                              :required="false">
                  <span slot="label">Postcode</span>
                </v-text-field>
              </b-col>
            </b-row>
            <!--/Address-->

            <!--Contact-->
            <b-row>
              <b-col>
                <v-text-field v-model="form.website" type="text" name="website" placeholder="Enter website"
                              :required="false">
                  <span slot="label">Website</span>
                </v-text-field>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <v-text-field :v="$v.form['email']" v-model="form.email" type="email" name="email" placeholder="Email"
                              :required="true" @blur="$v.form['email'].$touch()" @focus="$v.form['email'].$reset()">
                  <span slot="label">Email</span>
                </v-text-field>
              </b-col>
              <b-col>
                <v-text-field v-model="form.secondary_email" type="email" name="secondary_email"
                              placeholder="Secondary Email" :required="false">
                  <span slot="label">Secondary Email</span>
                </v-text-field>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <v-text-field :v="$v.form['phone']" v-model="form.phone" type="email" name="phone" placeholder="Phone"
                              :required="true" @blur="$v.form['phone'].$touch()" @focus="$v.form['phone'].$reset()">
                  <span slot="label">Phone</span>
                </v-text-field>
              </b-col>
              <b-col cols="4">
                <v-text-field v-model="form.mobile" type="email" name="mobile" placeholder="Mobile" :required="false">
                  <span slot="label">Mobile</span>
                </v-text-field>
              </b-col>
              <b-col cols="4">
                <v-text-field v-model="form.fax" type="email" name="fax" placeholder="Fax" :required="false">
                  <span slot="label">Fax</span>
                </v-text-field>
              </b-col>
            </b-row>
            <!--/Contact-->

            <!--/card-body-->
            <div slot="footer">
              <b-button type="submit" size="sm" variant="success" @click="submit">
                <i class="fa fa-dot-circle-o"></i> Save
              </b-button>
              <b-button type="reset" size="sm" variant="danger" to="/agents">
                <i class="fa fa-ban"></i> Cancel
              </b-button>
            </div>
          </b-card>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import {commonAgent, validationsAgent} from './mixins'

export default {
  name: 'AgentAdd',
  data () {
    return {
      form: {
        id: null,
        name: '',
        reference_id: '',
        building: '',
        street: '',
        city: '',
        country: '',
        postcode: '',
        website: '',
        email: '',
        secondary_email: '',
        phone: '',
        mobile: '',
        fax: '',
        vat: null
      },
      select2Country: null
    }
  },
  validations: {
    ...validationsAgent
  },
  methods: {
    submit () {
      if (this.checkForm()) {
        let xhr = this.$store.dispatch('agents/store', this.form)

        xhr.then(
          (res) => {
            this.$router.push({ path: '/agents/' + res.data.data.id + '/edit' })
          }
        )
      } else {
        this.$store.dispatch('app/addValidationError', 'The form needs your attention')
      }
    }
  },
  mixins: [commonAgent]
}
</script>



// WEBPACK FOOTER //
// src/views/agents/Add.vue